import { render, staticRenderFns } from "./CbxProductProvider.vue?vue&type=template&id=cc477022&"
import script from "./CbxProductProvider.vue?vue&type=script&lang=ts&"
export * from "./CbxProductProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports